module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"summary":{"total":"{0}건 {1}","description":"의 미입금 주문이 있습니다.","hint":"( {0} 기준 )"},"order":{"code":"주문번호: {0}","created_at":"주문일: {0}","bank_account":"{0} {1} {2}","sender_name":"(입금자: {0})","copy_bank_account_no":"계좌번호 복사"}}}')
  delete Component.options._Ctor
}
